var app = angular.module("leonardo");

var SkipFormDialog = function ($scope) {


  $scope.task = $scope.ngDialogData.task;

  $scope.showResolveDialog = function () {
    $scope.confirm();
  };

};

app.controller('SkipFormDialog', ['$scope',
  SkipFormDialog]);
